"use client";

import Script from "next/script";
import { GoogleTagManager, GoogleAnalytics } from "@next/third-parties/google";

export default function TrackingScripts({
  trackingIds,
}: {
  trackingIds: { ga?: string; gtm?: string; mp?: string };
}) {
  return (
    <>
      {/* Google Tag Manager */}
      {trackingIds?.gtm && <GoogleTagManager gtmId={trackingIds.gtm} />}

      {/* Google Analytics */}
      {trackingIds?.ga && <GoogleAnalytics gaId={trackingIds.ga} />}

      {/* Meta Pixel */}
      {trackingIds?.mp && (
        <>
          <Script
            id="meta-pixel-script"
            strategy="afterInteractive"
          >
            {`
              !function(f,b,e,v,n,t,s)
              {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
              n.callMethod.apply(n,arguments):n.queue.push(arguments)};
              if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
              n.queue=[];t=b.createElement(e);t.async=!0;
              t.src=v;s=b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t,s)}(window, document,'script',
              'https://connect.facebook.net/en_US/fbevents.js');
              fbq('init', '${trackingIds.mp}');
              fbq('track', 'PageView');
            `}
          </Script>
          <noscript>
            <img
              height="1"
              width="1"
              style={{ display: "none" }}
              src={`https://www.facebook.com/tr?id=${trackingIds.mp}&ev=PageView&noscript=1`}
            />
          </noscript>
        </>
      )}
    </>
  );
}
